import PrimaryButton from "Components/atoms/buttons/primary-button"
import SearchFormContainer from "Components/atoms/containers/search-form-container"
import SearchSelect from "Components/molecule/inputs/search-select"
import MultiSelect from "Components/molecule/inputs/multi-select"
import { SelectOption } from "../../../molecule/inputs/select-input"
import CheckboxInput from "Components/molecule/inputs/checkbox-input"
import { IGrossMarginReportQuery } from "models/gross-margin-report"
import ToFromInput from "Components/molecule/inputs/to-from-input"
import SecondaryButton from "Components/atoms/buttons/secondary-button"
import useEnterSearch from "hooks/useEnterSearch"

interface SearchGrossMarginReportProps {
    branches: SelectOption[]
    departments: SelectOption[]
    fiscalPeriodOptions: SelectOption[]

    selectedBranches: SelectOption[]
    selectedDepartments: SelectOption[]

    fromFiscalPeriod: number
    toFiscalPeriod: number

    isSearching: boolean

    handleSearch: () => any
    handleClearSearch: () => void


    onChangeBranches: (v: SelectOption[]) => void
    onChangeDepartments: (v: SelectOption[]) => void
    onChangeTo: (_toFiscalPeriod?: number) => void,
    onChangeFrom: (_fromFiscalPeriod?: number) => void,
}

const SearchGrossMarginReportForm = ({
    handleSearch,
    handleClearSearch,
    onChangeBranches,
    onChangeDepartments,
    onChangeFrom,
    onChangeTo,
    fromFiscalPeriod,
    toFiscalPeriod,

    branches,
    departments,

    selectedDepartments,
    selectedBranches,

    fiscalPeriodOptions,
    isSearching = false
}: SearchGrossMarginReportProps) => {

    const { selectProps } = useEnterSearch(handleSearch)

    return (
        <SearchFormContainer
            inputs={
                <>

                    <ToFromInput
                        fromFiscalPeriod={fromFiscalPeriod}
                        toFiscalPeriod={toFiscalPeriod}
                        handleChangeTo={onChangeTo}
                        handleChangeFrom={onChangeFrom}
                        fiscalPeriodOptions={fiscalPeriodOptions}
                        containerStyle={{ flex: "4 200px" }}
                        {...selectProps}
                    />
                    <MultiSelect
                        containerStyle={{
                            flex: "4 150px"
                        }}
                        className="col"
                        label="Branch"
                        options={branches}
                        value={selectedBranches}
                        onChange={onChangeBranches}
                        placeholder="Select branches"
                    />
                    <MultiSelect
                        containerStyle={{
                            flex: "12 250px"
                        }}
                        className="col"
                        label="Department"
                        options={departments}
                        value={selectedDepartments}
                        onChange={onChangeDepartments}
                        placeholder="Select departments"
                    />
                </>
            }
            clearSearchButton={
                <>
                    <PrimaryButton
                        style={{ minWidth: '150px' }}
                        disabled={isSearching}
                        onClick={handleSearch}
                    >
                        {isSearching ? 'Searching...' : 'Search'}
                    </PrimaryButton>
                    <SecondaryButton
                        style={{ minWidth: '100px' }}
                        disabled={isSearching}
                        onClick={handleClearSearch}
                    >
                        Clear Search
                    </SecondaryButton>
                </>
            }
        />
    )
}

export default SearchGrossMarginReportForm
